var map = {
  "./pl.messages.tsx": [
    "52500",
    [
      3786
    ]
  ],
  "./cs.messages.tsx": [
    "19634",
    [
      1460
    ]
  ],
  "./en.messages.tsx": [
    "44251",
    [
      3707
    ]
  ],
  "./hu.messages.tsx": [
    "99791",
    [
      8779
    ]
  ],
  "./de.messages.tsx": [
    "37667",
    [
      2559
    ]
  ],
  "./it.messages.tsx": [
    "90365",
    [
      5961
    ]
  ],
  "./sk.messages.tsx": [
    "17850",
    [
      7628
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 49857;
module.exports = __rspack_async_context;
